import type {FC} from 'react';

import {useI18n} from '@yourcoach/i18n';

import UploadSVG from '../../../../assets/icons/primary/Upload.svg';
import {Button} from '../../../../uikit/Button';

type Props = {
  onClick: () => void;
};

export const ShareButton: FC<Props> = ({onClick}) => {
  const {t} = useI18n();

  return (
    <Button icon={UploadSVG} iconColor="icon3" onClick={onClick} scheme="gray">
      {t('shared:share')}
    </Button>
  );
};
